module.exports = __webpack_public_path__ + "files/4729ae8d1a3f74c4bcb33ec4687e761e.png";